import Flex from '@/components/common/Flex';
import RadioItem from '@/components/settings-panel/RadioItem';
import AppContext from '@/context/Context';
import { ButtonGroup, Form } from 'react-bootstrap';
import { titleReturner } from '../pages/Appearance';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import darkModeImg from '@/assets/img/mizfa-tools-dark-min.png';
import defaultModeImg from '@/assets/img/mizfa-tools-white-min.png';
import { useContext } from 'react';
import type { AppContextValue, NavbarPosition } from '@/config';
import {
  useAiSupportPlace,
  writeAiSupportPlace
} from '@/components/navbar/AiSupportFab';

const AppearanceContent = () => {
  const {
    config: {
      isFluid,
      isDark,
      navbarPosition,
      themeVariant,
      disabledNavbarPosition
    },
    changeThemeVariant,
    changeTheme,
    setConfig
  } = useContext(AppContext) as AppContextValue;
  const aiSupportPlace = useAiSupportPlace();

  const titleReturner2 = (title: string): string | undefined => {
    switch (title) {
      case 'left':
        return 'چپ صفحه';

      case 'none':
        return 'مخفی';

      case 'right':
        return 'راست صفحه';

      default:
        break;
    }
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Flex alignItems="center" tag="h5" className="fs-0 mb-3">
          حالت صفحه نمایش
        </Flex>
        <ButtonGroup className="btn-group-navbar-style">
          <RadioItem
            name="theme-mode"
            label="حالت روز"
            active={!isDark}
            onChange={() => changeTheme('light')}
            image={defaultModeImg}
          />
          <RadioItem
            name="theme-mode"
            label="حالت شب"
            active={isDark}
            onChange={() => changeTheme('dark')}
            image={darkModeImg}
          />
        </ButtonGroup>
        <hr />
        <Flex alignItems="center" tag="h5" className="fs-0 mt-3 mb-3">
          رنگ پنل کاربری
        </Flex>
        <div className="d-flex flex-wrap gap-2">
          {[
            { variant: 'primary', label: 'پیش‌فرض', color: '#e2cc9e' },
            { variant: 'teal', label: 'سبز آبی', color: '#02928b' },
            { variant: 'green', label: 'سبز', color: '#10b981' },
            { variant: 'blue', label: 'آبی', color: '#3b82f6' },
            { variant: 'purpureus', label: 'بنفش', color: '#a855f7' },
            { variant: 'yellow', label: 'زرد', color: '#dfba03' },
            { variant: 'orange', label: 'نارنجی', color: '#f97316' },
            { variant: 'red', label: 'قرمز', color: '#ef4444' },
            { variant: 'pink', label: 'صورتی', color: '#ec4899' }
          ].map(({ variant, color, label }) => (
            <div key={variant}>
              <ChildrensTooltip
                html={label}
                showOnHover={false}
                delayToRemove={100}
                placement="top"
              >
                <Form.Check
                  inline
                  checked={themeVariant === variant}
                  onClick={() => {
                    changeThemeVariant(variant);
                  }}
                  name="group1"
                  className={`theme-changer-${variant}`}
                  type="radio"
                />
              </ChildrensTooltip>
              <style>{`
              .theme-changer-${variant} {margin-left:0;}
              .theme-changer-${variant} .form-check-input[type=radio] {background-color:${color};cursor:pointer;padding:15px;}
              .theme-changer-${variant} .form-check-input[type=radio]:checked {background-color:${color} !important;background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2210%22%20width%3D%228.75%22%20viewBox%3D%220%200%20448%20512%22%3E%3C!--!Font%20Awesome%20Free%206.5.2%20by%20%40fontawesome%20-%20https%3A%2F%2Ffontawesome.com%20License%20-%20https%3A%2F%2Ffontawesome.com%2Flicense%2Ffree%20Copyright%202024%20Fonticons%2C%20Inc.--%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22M438.6%20105.4c12.5%2012.5%2012.5%2032.8%200%2045.3l-256%20256c-12.5%2012.5-32.8%2012.5-45.3%200l-128-128c-12.5-12.5-12.5-32.8%200-45.3s32.8-12.5%2045.3%200L160%20338.7%20393.4%20105.4c12.5-12.5%2032.8-12.5%2045.3%200z%22%2F%3E%3C%2Fsvg%3E"); !important;background-size: 17px;} 
          `}</style>
            </div>
          ))}
        </div>
        <hr />
        <div className="d-flex flex-column">
          <div className="d-flex gap-2 align-items-center">
            <h5 className="fs-0">تمام عرض کردن پنل کاربری </h5>
            <Form.Check
              type="switch"
              id="fluid-mode-switch"
              checked={isFluid}
              onChange={({ target }) => setConfig('isFluid', target.checked)}
            />
          </div>
        </div>
        <hr />
        <Flex>
          <div>
            <Flex alignItems="center" tag="h5" className="fs-0 mb-3">
              محل منوی پنل کاربری
            </Flex>
            <Form.Select
              className="mb-3"
              size="sm"
              defaultValue={navbarPosition}
              onChange={({ target }) =>
                setConfig('navbarPosition', target.value as NavbarPosition)
              }
            >
              {(['vertical', 'top', 'combo'] as const).map(option => (
                <option
                  key={option}
                  disabled={disabledNavbarPosition.includes(option)}
                  value={option}
                >
                  {titleReturner(option)}
                </option>
              ))}
            </Form.Select>
          </div>
        </Flex>
      </Form.Group>
      <hr />
      <Flex>
        <div>
          <Flex alignItems="center" tag="h5" className="fs-0 mb-3">
            محل قرارگیری پشتیبان AI
          </Flex>
          <Form.Select
            className="mb-3"
            size="sm"
            value={aiSupportPlace}
            onChange={({ target }) => {
              writeAiSupportPlace(target.value);
            }}
          >
            {['left', 'right', 'none'].map(option => (
              <option key={option} value={option}>
                {titleReturner2(option)}
              </option>
            ))}
          </Form.Select>
        </div>
      </Flex>
    </>
  );
};

export default AppearanceContent;
